export function track(eventName: string, eventData: {}) {
    if (window.mixpanel) {
        try {
            window.mixpanel.track(eventName, eventData);
        } catch (error) {
            console.error(
                `Mixpanel: cannot log an event. Error message: [${error.message}].`
            );
        }
    } else {
        console.error('Mixpanel: not available.');
    }
}

export function alias(user_id: string) {
    if (window.mixpanel) {
        try {
            window.mixpanel.alias(user_id);
        } catch (error) {
            console.error(
                `Mixpanel: cannot alias the user ${user_id}. Error message: [${error.message}].`
            );
        }
    } else {
        console.error('Mixpanel: not available.');
    }
}

export function identify(user_id: string) {
    if (window.mixpanel) {
        try {
            window.mixpanel.identify(user_id);
        } catch (error) {
            console.error(
                `Mixpanel: cannot identify the user ${user_id}. Error message: [${error.message}].`
            );
        }
    } else {
        console.error('Mixpanel: not available.');
    }
}

export function peopleSet(json_data: {}) {
    if (window.mixpanel) {
        try {
            window.mixpanel.people.set(json_data);
        } catch (error) {
            console.error(
                `Mixpanel: cannot set people data. Error message: [${error.message}].`
            );
        }
    } else {
        console.error('Mixpanel: not available.');
    }
}

export function timeEvent(event_name: string) {
    if (window.mixpanel) {
        try {
            mixpanel.time_event(event_name);
        } catch (error) {
            console.error(
                `Mixpanel: cannot start event time for [${event_name}]. Error message: [${error.message}].`
            );
        }
    } else {
        console.error('Mixpanel: not available.');
    }
}
